import * as React from 'react';
import { customizable, nullRender } from './druid/./druid/./druid/Utilities';
import { DefaultButton } from './druid/DefaultButton/DefaultButton';
import { IButtonProps } from './druid/Button.types';

/**
 * {@docCategory Button}
 */
@customizable('PrimaryButton', ['theme', 'styles'], true)
export class PrimaryButton extends React.Component<IButtonProps, {}> {
  public render(): JSX.Element {
    return <DefaultButton {...this.props} primary={true} onRenderDescription={nullRender} />;
  }
}
